import { Button, PageContainer } from "@govlaunch/web";
import Link from "next/link";
import React from "react";
import { useToggle } from "react-use";
import { useSelfie } from "~/components/auth/Auth";
import ProductWasSuggestedMessage from "~/components/product/marketplace/ProductWasSuggestedMessage";
import SuggestProductPopover from "~/components/product/marketplace/SuggestProductPopover";
import GovernmentsStackIcon from "~/src/components/product/icons/GovernmentsStackIcon";
import SavedProductsIcon from "~/src/components/product/icons/SavedProductsIcon";
import SuggestProductIcon from "~/src/components/product/icons/SuggestProductIcon";
import nextLinkHref from "~/src/utils/nextLinkHref";
import { FormattedMessage } from "react-intl";

export default function ProductsListingPageHeader() {
  const viewer = useSelfie();
  const [productWasSuggested, toggleProductWasSuggested] = useToggle(false);
  const [isSuggestProductOpen, toggleSuggestProductPopover] = useToggle(false);

  return (
    <>
      <PageContainer my={3}>
        {viewer &&
          (viewer.__typename === "GovernmentUser" || (viewer.__typename === "PendingUser" && viewer.verified)) && (
            <SuggestProductPopover
              isOpen={isSuggestProductOpen}
              onRequestClose={toggleSuggestProductPopover}
              onSuggestProduct={() => {
                toggleProductWasSuggested(true);
                toggleSuggestProductPopover();
              }}
            >
              {({ innerRef }: { innerRef: React.RefObject<any> }) => (
                <Button
                  ref={innerRef}
                  leftIcon={SuggestProductIcon}
                  onClick={() => {
                    if (!isSuggestProductOpen) {
                      toggleProductWasSuggested(false);
                    }

                    toggleSuggestProductPopover();
                  }}
                >
                  <FormattedMessage defaultMessage="Suggest Product" id="ofg0+9" />
                </Button>
              )}
            </SuggestProductPopover>
          )}

        {viewer && (
          <Link
            href={nextLinkHref("/user", {
              userSlug: viewer.slug,
              tab: "saved",
              subtab: "products",
            })}
            as={`/@${viewer.slug}/saved?tab=products`}
            passHref={true}
            legacyBehavior={true}
          >
            <Button leftIcon={SavedProductsIcon} as="a">
              <FormattedMessage defaultMessage="Saved Products" id="nvxvwL" />
            </Button>
          </Link>
        )}

        {viewer && viewer.__typename === "GovernmentUser" && (
          <Link
            href={nextLinkHref("/government", {
              governmentSlug: viewer.government.slug,
              content: "products",
            })}
            as={`/governments/${viewer.government.slug}/products`}
            passHref={true}
            legacyBehavior={true}
          >
            <Button leftIcon={GovernmentsStackIcon} as="a">
              <FormattedMessage defaultMessage="Government Stack" id="8ZSgve" />
            </Button>
          </Link>
        )}
      </PageContainer>

      {productWasSuggested && (
        <PageContainer my={3}>
          <ProductWasSuggestedMessage />
        </PageContainer>
      )}
    </>
  );
}
